import React from "react";
import RouteManager from "../../managers/RouteManager";
import DKKanban from "./DKKanban";
import Utility, { deepClone, swapArrayElement } from "../../utility/Utility";
import {
  DKIcons,
  DKLabel,
  DKIcon,
  DKButton,
  DKInputForm,
  INPUT_VIEW_DIRECTION,
  INPUT_TYPE,
  showLoader,
  removeLoader,
  TOAST_TYPE,
  showToast,
  DKListPicker,
  showAlert,
  DKFilterPopup,
  DKSpinner
} from "deskera-ui-library";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import Table from "../../services/table";
import { showFormPopup } from "../menu/AddNewRecordPopup";
import { DealManager } from "../../managers/DealManager";
import {
  COMMON_EVENTS,
} from "../../services/event/commonEvents";
import DataGridHolder from "../common/DataGridHolder";
import { DEAL_VIEW } from "../../constants/Enum";
import JobPipelineService from "../common/Dashboard/JobPipeline";
import { StateManager } from "../../managers/StateManager";
import { FILE_TYPE } from "../../constants/Constant";
import { getFileUrlForDownload } from "../import_export/utility/ExportData";
import ViewToggle from "../common/ViewToggle";
import ic_cells from "../../assets/icons/white/ic_cells.png";
import ic_kanban from "../../assets/icons/white/ic_kanban.png";
import ic_cells_white from "../../assets/icons/white/ic_cells_white.png";
import ic_kanban_white from "../../assets/icons/white/ic_kanban_white.png";
import { PipelineManager } from "../../managers/PipelineManager";
import "./deal.scss";
import TableDataParser from "../../Helper/TableDataParser";
import KanbanService from "../../services/KanbanService";
import { isMobileWebView } from "../../utility/ViewportSizeUtils";
import ContactManager from "../../managers/ContactManager";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

const data = [
  {
    id: DEAL_VIEW.KANBAN,
    name: "Card",
    icon: ic_kanban_white,
    unselectedIcon: ic_kanban,
  },
  {
    id: DEAL_VIEW.GRID,
    name: "List",
    icon: ic_cells_white,
    unselectedIcon: ic_cells,
  },
];

let selectedData = []

export default class Resources extends React.Component {
  supportedFileTypes = {
    CSV: FILE_TYPE.CSV,
    XLSX: FILE_TYPE.XLSX,
  };
  pageSize = 20
  selectedPipelineId;
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      pipelineName: null,
      columnIndex: null,
      showAddStagePopUp: false,
      showAddCardPopUp: false,
      showAddPipelinePopup: false,
      name: "New Stage",
      cardName: "",
      cardAmount: 0,
      showAddDeal: false,
      needPipelineListPicker: false,
      selectedPipelineId: null,
      selectedPipelineIndex: 0,
      needViewsListPicker: false,
      selectedView: DEAL_VIEW.KANBAN,
      isStageEdit: false,
      toggleData: data,
      additionalFilterConditions: PipelineManager.filterConditions,
      needKanbanFilterPopup: false,
      defaultFilter: {},
      refreshKanban:false,
      hasMoreLoad:false,
      searchStr:"",
      refresh:false
    };
    this.pipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
    this.stageTableId = TableManger.getTableId(TABLES.JOB_STAGE);
    this.dealTableId = TableManger.getTableId(TABLES.CANDIDATE);
    this.pipelines = [];
    this.dataToEdit = [];
    this.candidateData = [];
    this.exportTypes = Object.keys(this.supportedFileTypes);
  }
  componentDidMount() {
    RouteManager.setPresenter(this);
    this.getPipeline();
    document.addEventListener(COMMON_EVENTS.ADD_NEW_REC, (data) =>
      this.onNewRecordAdd(data)
    );
  }
  onNewRecordAdd = (data) => {
    if (data.detail.tableName === TABLES.CANDIDATE) {
      this.getStages();
    }
  };
  componentWillUnmount() {
    document.removeEventListener(COMMON_EVENTS.ADD_NEW_REC, (data) =>
      this.onNewRecordAdd(data)
    );
  }
  getPipeline = () => {
    let req = null;
    let payload = null;
    Table.getRecordsByPage(req, payload, this.pipelineTableId)
      .then((res) => {
        JobPipelineService.pipelineData = res.data;
        this.pipelines = DealManager.parsePipelineData(res);
        if(JobPipelineService.selectedPielineId) {
          const selectedIndex = this.pipelines?.findIndex(p=>p.id === JobPipelineService.selectedPielineId)
          if(selectedIndex !== -1) {
            localStorage.setItem("selectedPipeline", selectedIndex);
          }          
          JobPipelineService.selectedPielineId = null;
        }
        let index =
          localStorage.getItem("selectedPipeline") !== null
            ? localStorage.getItem("selectedPipeline")
            : 0;
        this.setState(
          {
            pipelineName: this.pipelines[index].pipelineName,
            selectedPipelineIndex: index,
          },
          () => {
            this.getStages();
          }
        );
      })
      .catch((err) => {});
  };
  getStages = () => {
    Table.getRecords(this.stageTableId).then((res) => {
      JobPipelineService.stageData = res;
      const data = {
        data: res,
      };
      DealManager.putStagesInPipeline(this.pipelines, data);
      
      this.setState({
        columns: this.pipelines[this.state.selectedPipelineIndex]?.stages,
        selectedPipelineId:
          this.pipelines[this.state.selectedPipelineIndex]?.id,
      });
      this.selectedPipelineId = this.pipelines[this.state.selectedPipelineIndex]?.id
      this.getDeals(this.state.searchQuery);
    });
  };

  getCandidateFilters = (view, pipeline, additionalFilter) => {
    const filter = [];
    const addtionalFilter = deepClone(additionalFilter);
    addtionalFilter.forEach((condition) => {
      filter.push(TableManger.getFilterSubCondition(condition));
    });
    const defaultFilter = this.getDefaultFilter(view, pipeline);
    if (!Utility.isEmpty(defaultFilter)) {
      filter.push(defaultFilter);
    }
    const recordFilterJson = {
      logicalOperator: "and",
      conditions: filter,
    };

    const payload = ContactManager.getFilterPayload(recordFilterJson);
    return payload?.conditions ? payload.conditions : filter;

  };

  

  getDeals = async (searchStr) => {
    this.deals = [];
    const dealNameColumnId = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.NAME
    );
    const dealStageColumnId = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOB_STAGE_ID
    );
    const dealPipelineColumnId = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID
    );
    const dealContactColumnId = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.EMAIL
    );
    let dealColumns = {};
    const search = ""
    const searchQuery = searchStr || "";
    let filterPayload = TableManger.getFilterObject(
      this.props.tableMetaData?.filter?.conditions || [],
      this.props.tableMetaData?.filter?.logicalOperator
    );

    filterPayload = TableDataParser.getModifiedFilterPayload(filterPayload, this.filterableColumns);

    await PipelineManager.getStageMetaData(filterPayload, { q: searchQuery });
    let req = {
      pageNo: 1,
      pageSize: this.pageSize,
      q: search,
    };
    const payload = this.getCandidateFilters(
      this.state.selectedView,
      this.state.selectedPipelineId,
      this.state.additionalFilterConditions
    );
    const recordFilterJson = {
      logicalOperator: "and",
      conditions: payload,
    };
    

    filterPayload = TableDataParser.getModifiedFilterPayload(filterPayload, this.filterableColumns);
    if(isMobileWebView()) {
      showLoader()
    }
    this.setState({
      refreshKanban: true,
      searchQuery:searchQuery
    });
    KanbanService.fetchCandidateByStages(
      {
        params: { pipelineId: this.state.selectedPipelineId||this.selectedPipelineId, q: searchQuery, pageSize: this.pageSize },
          payload: { ...filterPayload },
      },
      {conditions: this.state.defaultFilter, logicalOperator: "and"}
      )
    
    .then(
      (res) => {
        if (res) {
          this.dataToEdit = [];
          res.data.forEach((record) => {
            TableManger.getTableColumns(TABLES.CANDIDATE).forEach((column) => {
              dealColumns[column.columnCode] = column;
            });
            this.dataToEdit.push({
              [dealColumns[COLUMN_CODE.CANDIDATE.NAME]?.id]:
                record.cells[dealColumns[COLUMN_CODE.CANDIDATE.NAME]?.id],
              [dealColumns[COLUMN_CODE.CANDIDATE.EMAIL]?.id]:
                record.cells[dealColumns[COLUMN_CODE.CANDIDATE.EMAIL]?.id],
              [dealColumns[COLUMN_CODE.CANDIDATE.ADDRESS]?.id]:
                record.cells[dealColumns[COLUMN_CODE.CANDIDATE.ADDRESS]?.id],
              [dealColumns[COLUMN_CODE.CANDIDATE.PHONE]?.id]:
                record.cells[dealColumns[COLUMN_CODE.CANDIDATE.PHONE]?.id],
              [dealColumns[COLUMN_CODE.CANDIDATE.JOBOPENING]?.id]:
                record.cells[dealColumns[COLUMN_CODE.CANDIDATE.JOBOPENING]?.id],
              [dealColumns[COLUMN_CODE.CANDIDATE.STATUS]?.id]:
                record.cells[dealColumns[COLUMN_CODE.CANDIDATE.STATUS]?.id],
              id: record?._id,
            });

            let duration = new Date() - new Date(record.createdAt);
            let hours = Math.round(duration / 3600 / 1000);
            let days = Math.round(hours / 24);
            this.deals.push({
              id: record._id,
              name: record.cells[dealNameColumnId],
              stage: record.cells[dealStageColumnId],
              pipeline: record.cells[dealPipelineColumnId],
              date:
                hours === 0 || isNaN(hours)
                  ? "Just created"
                  : hours > 24
                    ? days > 1
                      ? days + " days ago"
                      : days + " day ago"
                    : hours + " hrs ago",
              contact: record.cells[dealContactColumnId]
                ? record.cells[dealContactColumnId]
                : "",
            });
          });
          const pipelineStageMetaData = PipelineManager.stageMetaData;
          DealManager.dealKanBanColumns = this.pipelines[this.state.selectedPipelineIndex]?.stages;
          let hasMoreLoad = false
          this.pipelines.forEach((pipeline) => {
            const currentPipeline = pipelineStageMetaData?.data?.find(p => p.pipelineId === pipeline.id);
            pipeline.stages.forEach((stage) => {
              const currentStage = currentPipeline?.data?.find?.(
                (s) => s.stageId === stage.id
              );
              let candidates = [];
              this.deals.forEach((candidate) => {
                if (candidate.stage && candidate.stage.includes(stage.id)) {
                  candidates.push(candidate);
                }
              });
              stage.candidate = candidates;
              stage.candidateCount = currentStage?.candidateCount || 0;
              if (currentStage?.candidateCount && currentStage?.candidateCount > this.pageSize) {
                hasMoreLoad = true
              }
            });
          });
          this.setState({
            columns: this.pipelines[this.state.selectedPipelineIndex].stages,
            hasMoreLoad: hasMoreLoad,
            searchQuery:searchQuery
          });
        }
      }
    ).finally(() => {
      removeLoader()
      this.setState({
        refreshKanban: false,
        searchQuery: searchQuery
      });
    });;
  };

  render() {
    return (
      <div className="parent-width align-items-start parent-height">
        {this.pipelines.length !== 0 && this.getHeaderWithActions()}
        {this.state.showAddPipelinePopup && this.getAddPipelinePopup()}
        {this.state.showAddStagePopUp && this.getAddStagePopup()}
        {this.state.selectedView === DEAL_VIEW.KANBAN && (
          
            <DKKanban
              columns={this.state.columns}
              hasMoreLoad = {this.state.hasMoreLoad}
              allowColumnShifting
              customHeaderRender={this.getHeader}
              customCardRender={this.getCard}
              onCardDragStart={(card, columnIndex) =>
                this.onCardDrag(card, columnIndex)
              }
              onCardDrop={(card, fromColumnIndex, toColumnIndex) =>
                this.onCardDrop(card, fromColumnIndex, toColumnIndex)
              }
              onCardAdd={(index) => this.onCardAdd(index)}
              onColumnShift={this.onColumnShift}
              onLoadMore={() => {
                this.pageSize = this.pageSize + 20;
                this.getDeals(this.state.searchQuery);
              }}
              onSearch={(value)=>this.getDeals(value)}
              loading={this.state.refreshKanban}
            />
          
        )}
        {this.state.selectedView === DEAL_VIEW.GRID && (
          <DataGridHolder
            tableName={TABLES.CANDIDATE}
            module={MODULE.CANDIDATE}
            allowRowEdit={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.EDIT])}
            allowColumnEdit={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.EDIT])}
            allowRowAdd={false}
            allowColumnAdd={false}
            allowColumnDelete={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.DELETE])}
            allowColumnShift={true}
            allowSearch={true}
            allowFilter={false}
            onRowDelete={(data) => {}}
            onRowEdit={(data) => {
              this.showDetail(data.rowData);
            }}
            onRowOpenClick={(data)=>{
              this.showPopup(data.rowData);
            }}
            refresh={this.state.refresh}
            allowDataExport={true}
            filter={this.state.defaultFilter}
            isSelectOptionShow={true}
            onRowSelect={(selectedRows) => {
              selectedData = selectedRows?.map((row) => row.id) || [];
            }}
            addButtonConfig={true}
          />
        )}
      </div>
    );
  }

  toggleExportPicker = (exporting = false) => {
    this.setState((prevState) => ({
      showExportPicker: !prevState.showExportPicker,
      refresh: exporting,
      exportInProgress: exporting,
    }));
  };
  onSelectExportType = (fileType) => {
    if(this.dataToEdit && this.dataToEdit.length > 0) {
      const queryParams = {
        format: fileType,
        timezoneOffset: new Date().getTimezoneOffset() * -1,
      };
      let ids = [];
      let filters = this.getDefaultFilter(
        this.state.selectedView,
        this.state.selectedPipelineId,
        true
      );
      if(!Utility.isEmpty(selectedData)) {
        ids = selectedData;
      }

      const payload = { ids: ids, filter: {"logicalOperator":"and","conditions":[...this.state.additionalFilterConditions,filters]} };

      const options = {
        endPointOptions: TableManger.getTableId(TABLES.CANDIDATE),
        fileName: "candidate",
        fileType: this.supportedFileTypes[fileType],
      };

      getFileUrlForDownload(queryParams, payload, options)
        .then((res) => {
          selectedData = []
          this.setState({ exportInProgress: false, refresh: false });
        })
        .catch((error) => {
          showToast(error, TOAST_TYPE.FAILURE);
        });
    } else {
      showToast(
        `Please ensure you have candidates in your pipeline before exporting.`,
        TOAST_TYPE.DEFAULT
      );
    }
    this.toggleExportPicker(true);
  };

  onCardDrag = (card, columnIndex) => {};
  onCardDrop = (card, fromIndex, toIndex) => {
    const StageIdColumnId = TableManger.getColumnId(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOB_STAGE_ID
    );
    let data = {
      [StageIdColumnId]: [
        this.pipelines[this.state.selectedPipelineIndex].stages[toIndex].id,
      ],
    };
    Table.updateRecord(data, card.id, this.dealTableId).then((data) => {
      this.getDeals(this.state.searchQuery);
    });
  };

  getDefaultFilter(view, pipelineId,isExport) {
    let filter = {};
    if (view === DEAL_VIEW.GRID || isExport) {
      const pipelineColumnId = TableManger.getColumnId(
        TABLES.CANDIDATE,
        COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID
      );
      const stageColumnId = TableManger.getColumnId(
        TABLES.CANDIDATE,
        COLUMN_CODE.CANDIDATE.JOB_STAGE_ID
      );
      filter = {
        colId: pipelineColumnId,
        value: [pipelineId],
        opr: "eq",
      };
    }
    return filter;
  }

  onViewChange(data, index) {
    let payload = this.getCandidateFilters(
      data.id,
      this.state.selectedPipelineId,
      this.state.additionalFilterConditions
    );
    if(data.id === DEAL_VIEW.KANBAN) {
      selectedData = [];
      this.getDeals();
    }
    this.setState({
      selectedView: data.id,
      defaultFilter: payload,
    });
  }

  toggleFilterPopup = (shouldOpen) => {
    this.setState((prevState) => ({
      needKanbanFilterPopup: shouldOpen ?? !prevState.needKanbanFilterPopup,
    }));
  };

  getFilterPopup() {
    this.filterableColumns = this.getUpdatedFilterableColumns();

    return (
      <DKFilterPopup
        filterData={[...this.state.additionalFilterConditions]}
        headers={this.filterableColumns}
        onSubmit={(data) => {
          this.toggleFilterPopup(false);
          this.setAdditionalFilterConditions(
            { query: data },
            this.state.selectedView === DEAL_VIEW.KANBAN
          );
        }}
        onCancel={() => this.toggleFilterPopup(false)}
      />
    );
  }

  getUpdatedFilterableColumns = () => {
    return (
      TableManger.getTableVisibleColumns(TABLES.CANDIDATE)
        ?.filter((obj) => {
          return (
            obj.type &&
            obj.type !== INPUT_TYPE.BUTTON &&
            obj.type !== INPUT_TYPE.MORE &&
            obj.columnCode !== COLUMN_CODE.DEAL.ATTACHMENT &&
            (obj.allowFilter ?? true)
          );
        })
        .map((obj) => {
          if (
            obj.id ===
            TableManger.getColumnId(
              TABLES.CANDIDATE,
              COLUMN_CODE.CANDIDATE.JOB_STAGE_ID
            )
          ) {
            return {
              ...obj,
              type: INPUT_TYPE.SELECT,
              options: PipelineManager.getStagesForCurrentPipeline(),
            };
          }

          return obj;
        }) || []
    );
  };

  setAdditionalFilterConditions = (data, refresh = false) => {
    PipelineManager.filterConditions = data?.query || [];
    let payload = this.getCandidateFilters(
      this.state.selectedView,
      this.state.selectedPipelineId,
      data?.query
    );
    this.setState(
      {
        additionalFilterConditions: data?.query || [],
        defaultFilter: payload,
      },
      () => {
        this.refreshDealData();
      }
    );
  };

  refreshDealData = (forceGridUpdate = true) => {
    const refreshKanban = this.state.selectedView === DEAL_VIEW.KANBAN;
    this.getDeals(this.state.searchQuery);
  };

  getHeaderWithActions() {
    return (
      <div className="row row-responsive parent-width justify-content-between">
        <div className="row width-auto pb-s">
          {this.pipelines.length !== 0 && (
            <div className={`row justify-content-between align-items-start ${isMobileWebView() ? "maxwidth-pipeline":"parent-width "}`}>
              <div
                className="row justify-content-between p-h-r p-v-s border-m bg-white border-radius-m position-relative cursor-hand  shadow-m"
                onClick={this.toggleVisibilityOfPipeline}
                // style={{ width: 150 }}
              >
                <DKLabel
                  className={`unselectable ${isMobileWebView() ? "ellipsis":""}`}
                  text={
                    this.pipelines[this.state.selectedPipelineIndex]
                      .pipelineName
                  }
                />
                <DKIcon
                  src={DKIcons.ic_arrow_down2}
                  className="ic-s unselectable ml-s"
                />
                {this.state.needPipelineListPicker &&
                  this.getPipelineListPicker()}
              </div>
            </div>
          )}
          
          {(this.state.selectedView === DEAL_VIEW.KANBAN && PermissionUtils.hasAccess(MODULE.JOB_PIPELINE, [ACTION.EDIT, ACTION.CREATE])) && (
            <DKButton
              icon={DKIcons.ic_add}
              title={!isMobileWebView() ? "Add Stage" : null}
              className="bg-white border-m m-h-r shadow-m"
              onClick={() => {
                this.showHideStagePopup();
              }}
            />
          )}
          {(this.state.refreshKanban && this.state.selectedView === DEAL_VIEW.KANBAN && !isMobileWebView()) && (
              <DKSpinner className="ml-r" />
            )}
          
        </div>
        <div className="pb-s">
          <div className="row-reverse">
            <ViewToggle
              data={this.state.toggleData}
              selectedView={this.state.selectedView}
              onViewChange={(data, index) => {
                this.onViewChange(data, index);
              }}
            />
            {this.dataToEdit &&
              this.getExportPipeline()}
            <div className="row width-auto position-relative kanban-filter-container pr-s">
              <DKIcon
                src={DKIcons.ic_filter}
                className="ic-s bg-white p-s border-m border-radius-m cursor-hand"
                onClick={() => this.toggleFilterPopup()}
              />
              {this.state.additionalFilterConditions?.length ? (
                <div
                  className="position-absolute bg-red circle"
                  style={{
                    width: 5,
                    height: 5,
                    top: 0,
                    left: 30,
                  }}
                ></div>
              ) : null}
              {this.state.needKanbanFilterPopup && this.getFilterPopup()}
            </div>
          </div>
        </div>
      </div>
    );
  }

  getExportPipeline() {
    return (
      <div className="column">
        {((!isMobileWebView()) && PermissionUtils.hasAccess(MODULE.JOB_PIPELINE,ACTION.EXPORT) )&&<DKButton
          icon={DKIcons.ic_export}
          title="Export"
          className="bg-white border-m mr-r shadow-m"
          onClick={() => {
            this.toggleExportPicker(false);
          }}
        />}
        {this.state.showExportPicker ? (
          <DKListPicker
            className="border-m shadow-m parent-width z-index-3 position-absolute ml-r"
            style={{ top: 57, width: 90 }}
            data={this.exportTypes}
            onSelect={(index) =>
              this.onSelectExportType(this.exportTypes[index])
            }
            onClose={() => {
              setTimeout(() => {
                this.setState({ showExportPicker: false });
              }, 10);
            }}
          />
        ) : null}
      </div>
    );
  }

  getCard = (card, colIndex, rowIndex) => {
    return (
      <div
        className="bg-white border-m border-radius-s p-r parent-width border-box cursor-hand stage-holder"
        onClick={() => {
          if(PermissionUtils.hasAccess(MODULE.CANDIDATE,ACTION.VIEW)) {
            RouteManager.navigateToPage(`/candidate/${card.id}`);
          }
        }}
      >
        <div className="row justify-content-between stage-wrap">
          <DKLabel text={`${card.name}`} className="text-app fw-m ellipsis" />
          {PermissionUtils.hasAccess(MODULE.CANDIDATE, ACTION.EDIT) && <DKIcon
            src={DKIcons.ic_edit}
            className="deal-card-icon stage-delete-icon"
            style={{ opacity: 0.15, userSelect: "none", height: "15px" }}
            onClick={(e) => this.openActionButtons(e, card)}
          />}
        </div>
        <div className="row mt-s">
          <DKLabel
            text={`${card.contact ? card.contact : card.contact}`}
            className="text-gray ellipsis"
          />
        </div>
        <DKLabel text={card.date} className="text-gray mt-s fs-s" />
      </div>
    );
  };
  getHeader = (column, colIndex) => {
    return (
      <div
        className="column justify-content-center parent-width p-v-s p-h-r bg-app border-box stage-holder"
        style={{ height: 58 }}
      >
        <div className="row mt-s stage-wrap parent-width">
          <div className="column parent-width">
            <div className="row">
              <DKLabel text={`${column.name}`} className={`fw-m text-white`} />
              {PermissionUtils.hasAccess(MODULE.JOB_PIPELINE, [ACTION.CREATE,ACTION.EDIT])&&<DKIcon
                src={DKIcons.ic_add_white}
                className={`ic-s-2 ml-m cursor-hand`}
                onClick={() => this.setColumnIndex(colIndex)}
              />}
            </div>
          </div>
          <div className="column stage-delete-icon">
            {!this.pipelines[this.state.selectedPipelineIndex].isDefault && (
              <div className="row">
                {PermissionUtils.hasAccess(MODULE.JOB_PIPELINE, [ACTION.EDIT]) && <DKIcon
                  src={DKIcons.white.ic_edit}
                  className="ic-s cursor-hand text-white mr-s"
                  onClick={() => {
                    this.setState({
                      columnIndex: colIndex,
                      isStageEdit: true,
                      showAddStagePopUp: true,
                    });
                  }}
                />}
                {PermissionUtils.hasAccess(MODULE.JOB_PIPELINE, [ACTION.DELETE])&&<DKIcon
                  src={DKIcons.white.ic_delete}
                  className="ic-s cursor-hand text-white ml-s"
                  onClick={() => this.getDeleteConfirmation(null,column,TABLES.JOB_STAGE)}
                />}
              </div>
            )}
          </div>
        </div>
        <div className="row pb-s">

          <DKLabel
            text={`Candidates ${column?.candidateCount || 0}`}
            className={`text-white mt-xs`}
            style={{ opacity: 0.7 }}
          />
        </div>
      </div>
    );
  };
  openActionButtons = (e, card) => {
    let contacts = [];
    e.stopPropagation();
    const pipelineColumn = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID
    );
    const segmentColumn = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOBOPENING
    );
    const stageColumn = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOB_STAGE_ID
    );
    const statusColumn = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.STATUS
    );
    const phoneColumn = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.PHONE
    );
    const contactColumn = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.EMAIL
    );
    const jobOpeningColumn = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOBOPENING
    );
    StateManager.get(TABLES.CANDIDATE, null, null).then((responseData) => {
      contacts = DealManager.contactData(responseData.data);
      let data = { ...this.dataToEdit.find((deal) => deal.id === card.id) };
      const contactFullDetail = contacts?.find(c=>c._id === card.id);
      if(contactFullDetail) {
        data = {
          ...data,
          ...contactFullDetail.cells
        }
      }
      
      
      data[stageColumn.id] = card ? card.stage : [];
      data[pipelineColumn.id] = card ? card.pipeline : [];
      data[segmentColumn.id] = this.getMergedData(
        data[segmentColumn.id],
        data[pipelineColumn.id]
      );
      data[statusColumn.id] = this.getMergedData(
        data[statusColumn.id],
        data[stageColumn.id]
      );
      // ContactManager.getDataToUpdate(data);
      showFormPopup(
        {
          tableName: TABLES.CANDIDATE,
          recordId: card.id,
          defaultValues: DealManager.getDefaultValues(data),
          displayName: TABLES.CANDIDATE,
          popupClass: 'custom-scroll'
        },
        () => {
          this.setState({ refresh: true });
        }
      );
    });
  };
  getAddPipelinePopup = () => {
    const direction = INPUT_VIEW_DIRECTION.VERTICAL;
    const fields = [
      {
        key: "pipeline_name",
        title: "Pipeline name",
        type: INPUT_TYPE.TEXT,
        value: "",
        icon: DKIcons.ic_coupon,
        requestKey: TableManger.getColumnId(
          TABLES.JOB_PIPELINE,
          COLUMN_CODE.JOB_PIPELINE.NAME
        ),
      },
    ];
    return (
      <div className="transparent-background parent-height">
        <div className="popup-window" style={{ maxWidth: 450 }}>
          <div className="column parent-width">
            <div className="parent-width">
              <DKInputForm
                className=""
                direction={direction}
                title="Add Job Pipeline"
                fields={fields}
                dateFormat="MMM dd, yyyy"
                onCancel={() => {
                  this.showHidePipelinePopup();
                }}
                onSubmit={(data) => {
                  this.addPipeline(data);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  getAddStagePopup = () => {
    const direction = INPUT_VIEW_DIRECTION.VERTICAL;
    const fields = [
      {
        key: "field1",
        title: "Stage name",
        type: INPUT_TYPE.TEXT,
        value: this.state.isStageEdit
          ? this.pipelines[this.state.selectedPipelineIndex].stages[
              this.state.columnIndex
            ].name
          : "",
        icon: DKIcons.ic_coupon,
        requestKey: TableManger.getColumnId(
          TABLES.JOB_PIPELINE,
          COLUMN_CODE.JOB_PIPELINE.NAME
        ),
      },
    ];
    return (
      <div className="transparent-background parent-height">
        <div className="popup-window" style={{ maxWidth: 450 }}>
          <div className="column parent-width">
            <div className="parent-width">
              <DKInputForm
                className=""
                direction={direction}
                title={this.state.isStageEdit ? "Edit Stage" : "Add Stage"}
                fields={fields}
                dateFormat="MMM dd, yyyy"
                onCancel={() => {
                  this.showHideStagePopup();
                }}
                onSubmit={(data) => {
                  this.addStage(data);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  onCardAdd = (data) => {
    let columns = [...this.state.columns];
    columns[this.state.columnIndex].deals.unshift({
      name: data[0].value,
      amount: data[8].value,
    });
    this.setState({
      columns: columns,
      cardAmount: 0,
      cardName: "",
      showAddCardPopUp: false,
    });
  };
  onColumnShift = (fromIndex, toIndex) => {
    const stageIdsColumnId = TableManger.getColumnId(
      TABLES.JOB_PIPELINE,
      COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S
    );
    let columns = [...this.state.columns];
    swapArrayElement(columns, fromIndex, toIndex);
    this.setState({ columns: columns }, () => {
      let data = {
        [stageIdsColumnId]: this.state.columns.map((stage) => stage.id),
      };
      Table.updateRecord(
        data,
        this.pipelines[this.state.selectedPipelineIndex].id,
        this.pipelineTableId
      )
        .finally(() => removeLoader())
        .then((data) => {
          this.getPipeline();
        });
    });
  };
  showHidePipelinePopup = () => {
    this.setState({ showAddPipelinePopup: !this.state.showAddPipelinePopup });
  };
  showHideStagePopup = () => {
    this.setState({
      isStageEdit: false,
      showAddStagePopUp: !this.state.showAddStagePopUp,
    });
  };
  showHideAddCardPopup = (index) => {
    this.setState({ showAddCardPopUp: !this.state.showAddCardPopUp });
  };
  onNameChange = (name) => {
    this.setState({ name });
  };
  onCardNameChange = (cardName) => {
    this.setState({ cardName });
  };
  onCardAmountChange = (amount) => {
    let cardAmount = isNaN(amount) ? 0 : Number(amount);
    this.setState({ cardAmount });
  };
  setColumnIndex = (columnIndex) => {
    let wonDeal = this.pipelines[this.state.selectedPipelineIndex].stages.find(
      (stage) => stage.name === "Closed Won"
    );
    let lostDeal = this.pipelines[this.state.selectedPipelineIndex].stages.find(
      (stage) => stage.name === "Closed Lost"
    );
    let status = 0;
    if (
      wonDeal &&
      wonDeal.id ===
        this.pipelines[this.state.selectedPipelineIndex].stages[columnIndex].id
    ) {
      status = 1;
    } else if (
      lostDeal &&
      lostDeal.id ===
        this.pipelines[this.state.selectedPipelineIndex].stages[columnIndex].id
    ) {
      status = 2;
    } else {
      status = 0;
    }
    this.setState(
      {
        columnIndex: columnIndex,
      },
      () => {
        if(this.candidateData.length != 0) {
          this.showPopupForCandidate(columnIndex, status)
        } else {
          let req = {
            pageNo: 1,
            pageSize: 1000,
            q: "",
          };
          let payload = {
            conditions: [],
  logicalOperator: "and"
          }
          let tableId = TableManger.getTableId(TABLES.CANDIDATE)
          Table.getRecordsByPage(req, payload, tableId)
            .then((res) => {
              this.candidateData = res.data
              this.showPopupForCandidate(columnIndex, status)
            })
            .catch((err) => {
              removeLoader();
            });
          
        }        
        this.showHideAddCardPopup();
      }
    );
  };
  showPopupForCandidate(columnIndex, status) {
    showFormPopup({
      tableName: TABLES.CANDIDATE,
      displayName: "Candidate to job pipeline",
      defaultValues: DealManager.getDefaultValues({
        [TableManger.getColumnId(
          TABLES.CANDIDATE,
          COLUMN_CODE.CANDIDATE.JOB_STAGE_ID
        )]: [
          this.pipelines[this.state.selectedPipelineIndex].stages[
            columnIndex
          ].id,
        ],
        [TableManger.getColumnId(
          TABLES.CANDIDATE,
          COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID
        )]: [this.pipelines[this.state.selectedPipelineIndex].id],
        [TableManger.getColumnId(
          TABLES.CANDIDATE,
          COLUMN_CODE.CANDIDATE.STATUS
        )]: status,
      }),
      isCustomForm: true,
      inputData: this.candidateData,
      popupClass: "popup-overflow custom-scroll",
      candidateToFilter: this.pipelines[this.state.selectedPipelineIndex]?.stages[
        columnIndex
      ]?.candidate || []
    });
  }

  addStage = (data) => {
    const stagesColumnId = TableManger.getColumnId(
      TABLES.JOB_PIPELINE,
      COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S
    );
    let dataToSave = {};
    data.forEach((field) => {
      const stageNameColumnId = TableManger.getColumnId(
        TABLES.JOB_STAGE,
        COLUMN_CODE.JOB_STAGE.NAME
      );
      const stageWonColumnId = TableManger.getColumnId(
        TABLES.JOB_STAGE,
        COLUMN_CODE.JOB_STAGE.WON_STAGE
      );
      const stageLostColumnId = TableManger.getColumnId(
        TABLES.JOB_STAGE,
        COLUMN_CODE.JOB_STAGE.LOST_STAGE
      );
      const stageHelpTextColumnId = TableManger.getColumnId(
        TABLES.JOB_STAGE,
        COLUMN_CODE.JOB_STAGE.HELP_TEXT
      );
      const stageOrderColumnId = TableManger.getColumnId(
        TABLES.JOB_STAGE,
        COLUMN_CODE.JOB_STAGE.ORDER
      );
      dataToSave[stageNameColumnId] = field.value;
      dataToSave[stageWonColumnId] = false;
      dataToSave[stageLostColumnId] = false;
      dataToSave[stageHelpTextColumnId] = field.value;
      dataToSave[stageOrderColumnId] = 0;
    });
    if (this.state.isStageEdit) {
      Table.updateRecord(
        dataToSave,
        this.pipelines[this.state.selectedPipelineIndex].stages[
          this.state.columnIndex
        ].id,
        this.stageTableId
      ).then((data) => {
        this.setState({ showAddStagePopUp: !this.state.showAddStagePopUp });
        showToast("Stage updated Successfully.", TOAST_TYPE.SUCCESS);
        this.getPipeline();
      });
    } else {
      showLoader("Adding Stage...");
      Table.addRecord({ cells: dataToSave }, this.stageTableId)
        .finally(() => removeLoader())
        .then((response) => {
          this.setState({ showAddStagePopUp: !this.state.showAddStagePopUp });
          let stages = this.pipelines[
            this.state.selectedPipelineIndex
          ].stages.map((stage) => stage.id);
          stages.splice(stages.length - 2, 0, response.data._id);
          let data = { [stagesColumnId]: stages };
          Table.updateRecord(
            data,
            this.pipelines[this.state.selectedPipelineIndex].id,
            this.pipelineTableId
          ).then((data) => {
            showToast("Stage Added Successfully.", TOAST_TYPE.SUCCESS);
            this.getPipeline();
          });
        });
    }
  };
  addPipeline = (pipelineData) => {
    const stageNameColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.NAME
    );
    const stageWonColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.WON_STAGE
    );
    const stageLostColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.LOST_STAGE
    );
    const stageHelpTextColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.HELP_TEXT
    );
    const stageIdsColumnId = TableManger.getColumnId(
      TABLES.JOB_PIPELINE,
      COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S
    );
    const stageOrderColumnId = TableManger.getColumnId(
      TABLES.JOB_STAGE,
      COLUMN_CODE.JOB_STAGE.ORDER
    );
    let defaultStagesForNewPipeline = [];
    defaultStagesForNewPipeline.push({
      cells: {
        [stageNameColumnId]: "New Stage",
        [stageWonColumnId]: false,
        [stageLostColumnId]: false,
        [stageHelpTextColumnId]: "New Stage",
        [stageOrderColumnId]: 0,
      },
    });
    showLoader("Adding Pipeline...");
    Table.addBulkRecord(defaultStagesForNewPipeline, this.stageTableId).then(
      (response) => {
        let ids = [];
        response.data.forEach((stage) => {
          ids.push(stage._id);
        });
        let pipelineDataToSave = {};
        pipelineData.forEach((field) => {
          pipelineDataToSave[field.requestKey] = field.value;
          pipelineDataToSave[stageIdsColumnId] = ids;
        });
        Table.addRecord({ cells: pipelineDataToSave }, this.pipelineTableId)
          .finally(() => removeLoader())
          .then((data) => {
            showToast("Pipeline Added Successfully.", TOAST_TYPE.SUCCESS);
            localStorage.setItem("selectedPipeline", 0);
            this.getPipeline();
            this.setState({ showAddPipelinePopup: false });
          });
      }
    );
  };
  getPipelineListPicker() {
    let pipelineNames = [];
    this.pipelines.forEach((pipeline) => {
      pipelineNames.push(pipeline.pipelineName);
    });
    const addJobBtn = PermissionUtils.hasAccess(MODULE.JOB_PIPELINE, [ACTION.CREATE]) ? {
      title: "+ Add Job Pipeline",
      className: "bg-app text-white",
      onClick: () => {
        this.showHidePipelinePopup();
      },
    }:null

    return (
      <DKListPicker
        canEdit={false}
        canDelete={ PermissionUtils.hasAccess(MODULE.JOB_PIPELINE, ACTION.DELETE)}
        data={pipelineNames}
        className="position-absolute border-m shadow-m parent-width z-index-3 text-trailing pipeline-listpicker"
        style={{ top: 36, left: 0, width: 170 }}
        onSelect={(index, value) => {
          this.changePipeline(index, value);
        }}
        onEdit={(index, value) => {
        }}
        onDelete={(index, value) => {
          this.getDeleteConfirmation(
            null,
            this.pipelines[index],
            TABLES.JOB_PIPELINE
          );
        }}
        button={
          addJobBtn
      }
        onClose={() => {
          this.setState({ needPipelineListPicker: false });
        }}
      />
    );
  }
  changePipeline = (index, value) => {
    let SelectedPipeline = this.pipelines.find(
      (pipeline) => pipeline.pipelineName === value
    );
    localStorage.setItem("selectedPipeline", index);
    let filters = this.getDefaultFilter(
      this.state.selectedView,
      SelectedPipeline?.id
    );
    this.setState(
      {
        selectedPipelineId: SelectedPipeline?.id,
        selectedPipelineIndex: index,
        pipelineName: value,
        defaultFilter: filters,
      },
      () => this.getStages()
    );
  };
  toggleVisibilityOfPipeline = () => {
    this.setState({
      needPipelineListPicker: !this.state.needPipelineListPicker,
    });
  };
  getDeleteFunction = (data, table) => {
    switch (table) {
      case TABLES.JOB_PIPELINE:
        this.deletePipeline(data);
        break;
      case TABLES.JOB_STAGE:
        this.deleteStage(data);
        break;
      default:
        break;
    }
  };
  deleteStage = (selectedStage) => {
    const stageIdsColumnId = TableManger.getColumnId(
      TABLES.JOB_PIPELINE,
      COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S
    );
    const params = {
      isForceDelete: true
    }
    Table.deleteRecord(selectedStage.id, this.stageTableId, params).then((res) => {
      showToast("Stage Deleted Successfully.", TOAST_TYPE.SUCCESS);
      let stages = deepClone(this.pipelines[this.state.selectedPipelineIndex]?.stages);
      stages = stages?.filter((stage) => stage.id !== selectedStage.id) || [];
      stages = stages?.map(s=>s.id) || []
      let data = { [stageIdsColumnId]: stages };
      Table.updateRecord(
        data,
        this.pipelines[this.state.selectedPipelineIndex].id,
        this.pipelineTableId
      ).then((data) => {
        this.getPipeline();
      });
    });
  };

  deletePipeline = (pipeline) => {
    const seleectedPipeline = pipeline.id || ''
    this.changePipeline(0, false, false);
    const stageIdsColumnId = TableManger.getColumnId(
      TABLES.JOB_PIPELINE,
      COLUMN_CODE.JOB_PIPELINE.STAGE_ID_S
    );
    let data = {
      [stageIdsColumnId]:[]
    }
    showLoader('Please wait... Deleting Pipeline');
    const pipelineDetails = this.pipelines?.find(pipe=>pipe.id === pipeline.id)
    const stageIds = pipelineDetails?.stages?.map(res=>res.id) || []
    if (stageIds && stageIds.length > 0) {
      Table.deleteRecordInBulk(stageIds, this.stageTableId).then(
        (resStage) => {
          this.updateAndDeletePipeline(pipeline, data, seleectedPipeline);
        },
        (error) => {
          removeLoader();
        }
      );
    } else {
      this.updateAndDeletePipeline(pipeline, data, seleectedPipeline);
    }
  };
  updateAndDeletePipeline = (pipeline,data,seleectedPipeline) => {
    Table.updateRecord(data, seleectedPipeline, this.pipelineTableId).then((resUpdate) => {
      const params = {
        isForceDelete: true
      }
      Table.deleteRecord(pipeline.id, this.pipelineTableId,params).then((resDelete) => {
        this.getPipeline();
        removeLoader();
      },error=>{
        removeLoader();
      });
    },error=>{
      removeLoader();
    }); 
  }
  getDeleteConfirmation = (e, data, table) => {
    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
      {
        title: "Delete",
        className: "bg-red text-white ml-r",
        onClick: () => this.getDeleteFunction(data,table),
      },
    ];
    showAlert(
      "Delete Record?",
      "Deleting this record will delete it permanently you will not be able to restore it.",
      buttons
    );
  };
  getViewSelectionListPicker() {
    let views = [];
    views.push(
      { id: "1", name: DEAL_VIEW.KANBAN },
      { id: "2", name: DEAL_VIEW.GRID }
    );
    let viewList = [];
    views.forEach((view) => {
      viewList.push(view.name);
    });
    return (
      <DKListPicker
        data={viewList}
        className="position-absolute border-m shadow-m parent-width z-index-3"
        style={{ top: 36, left: 0 }}
        onSelect={(index, value) => {
          this.changeView(index, value);
        }}
      />
    );
  }
  toggleVisibilityOfViews = () => {
    this.setState({
      needViewsListPicker: !this.state.needViewsListPicker,
    });
  };
  changeView = (index, value) => {
    this.setState({ selectedView: value });
  };
  showPopup = (row = {}) => {
    let contacts = [];
    const contactColumn = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.PHONE
    );
    return Table.getRecordsByPage(
      null,
      DealManager.getQuery("personQuery"),
      TableManger.getTableId(TABLES.CONTACT)
    ).then((contact) => {
      contacts = DealManager.contactData(contact.data);
      let data = { ...this.dataToEdit.find((deal) => deal.id === row.id) };
      if (row[contactColumn.id])
        data[contactColumn.id] = [
          contacts.findIndex(
            (contact) => contact.id === row[contactColumn.id][0]
          ),
        ];
      showFormPopup(
        {
          tableName: TABLES.CANDIDATE,
          recordId: row.id,
          defaultValues: DealManager.getDefaultValues(row),
          displayName: TABLES.CANDIDATE,
          popupClass: 'custom-scroll'
        },
        () => {
          this.setState({ refresh: true });
        }
      );
    });
  };
  showDetail=(row={})=>{
    if(row?.id) {
      if(PermissionUtils.hasAccess(MODULE.CANDIDATE,ACTION.VIEW)) {
        RouteManager.navigateToPage(`/candidate/${row?.id}`)
      }
    }
  }

  getMergedData(param1, param2) {
    if (Array.isArray(param1)) {
      if (param2 && param2.length > 0) {
        param2.forEach((element) => {
          let isPresent = param1.some((x) => x === element);
          if (!isPresent) {
            param1.push(element);
          }
        });
      }
    }
    return param1 || [];
  }
}
